// @ts-nocheck
export const PASSWORD_FIELD = 'password'

export const getDefaultValues = () => ({
  [PASSWORD_FIELD]: '',
})